import { render, staticRenderFns } from "./AgentChat.vue?vue&type=template&id=30e23c66&scoped=true"
import script from "./AgentChat.vue?vue&type=script&lang=js"
export * from "./AgentChat.vue?vue&type=script&lang=js"
import style0 from "./AgentChat.vue?vue&type=style&index=0&id=30e23c66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e23c66",
  null
  
)

export default component.exports